/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

/**
 * Control the Multiple gesture short and long press on the same place.
 */
@Component({
  selector: 'app-multi-gestures',
  templateUrl: './multi-gestures.component.html',
  styleUrls: ['./multi-gestures.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiGesturesComponent {

  /**
   * Emit the left, right, long press gesture.
   */
  @Output() leftGesture: EventEmitter<void> = new EventEmitter();
  @Output() rightGesture: EventEmitter<void> = new EventEmitter();
  @Output() longGesture: EventEmitter<void> = new EventEmitter();

  /**
   * Emit the long press gesture.
   */
  onLongGesture() {
    this.longGesture.emit();
  }

  /**
   * Emit the left press gesture.
   */
  leftSide(): void {
    this.leftGesture.emit();
  }

  /**
   * Emit the right press gesture.
   */
  rightSide(): void {
    this.rightGesture.emit();
  }
}
